module.exports = __webpack_public_path__ + "img/DOLLAR_SIGN.7fc2cf96.svg";